// NOTE: This scroll to top is the default react scroll to top behavior when visiting a new route.
// For the scroll to top behavior on a click event I have created a custom hook with the name of useScrollToTop under the hooks folder that scrolls use to the top of the page when they scroll down on the page.

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
	const { hash, pathname } = useLocation();

	useEffect(() => {
		if (hash) {
			const id = decodeURIComponent(hash.replace('#', ''));
			let attempts = 0;

			const scrollToHash = () => {
				const target = document.getElementById(id);

				if (target) {
					target.scrollIntoView({ behavior: 'smooth', block: 'start' });
					return;
				}

				if (attempts < 12) {
					attempts += 1;
					window.setTimeout(scrollToHash, 50);
				}
			};

			scrollToHash();
			return;
		}

		window.scrollTo(0, 0);
	}, [hash, pathname]);
	return null;
};

export default ScrollToTop;
